import { AccountantActionTypes } from "./actionTypes";


const initialState = {
    accountantListError: null, message: null, isLoadingAddAccountant: false, isAddNewAccountantOpen: false,
    query: {
        page: 1,
        pageSize: 20,
        search: ''
    }
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case AccountantActionTypes.ACCOUNTANT_LIST_GET:
            state = {
                ...state,
                accountantList: null,
                accountantListError: null
            }
            break;
        case AccountantActionTypes.ACCOUNTANT_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                accountantList: action.payload,
                accountantListError: null
            }
            break;
        case AccountantActionTypes.ACCOUNTANT_LIST_GET_ERROR:
            state = {
                ...state,
                accountantList: null,
                accountantListError: action.payload
            }
            break;
        case AccountantActionTypes.SET_ACCOUNTANT_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case AccountantActionTypes.RESET_ACCOUNTANT_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default account;
